import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs";
import {DropDownModel, FetchReportsOptions} from "../model/reports.model";
import {v1URL} from "../../../shared/constants/urls.constants";
import {CommonService} from "../../../shared/services/common.service";

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  constructor(private commonService: CommonService) {
  }

  getAllReportsOptions(): Observable<DropDownModel['response']> {
    const urlConfig = v1URL.reports.getAllReportsType;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  getClinicsOptionsList(payload: { pageNumber: number, shouldInclude?: any,search?:string }): Observable<DropDownModel['response']> {
    let params: string = ''

    if (payload.pageNumber) {
      params = `pageNumber=${payload.pageNumber}`
    }

    if (payload?.shouldInclude?.length > 0) {
      params = params + `&shouldInclude=${payload.shouldInclude.join('&shouldInclude=')}`
    }

    if(typeof(payload?.shouldInclude) === 'number' && payload?.shouldInclude){
      params = params + `&shouldInclude=${payload.shouldInclude}`
    }

    if (payload?.search) {
      params = params + `&search=${payload.search}`
    }

    const urlConfig = v1URL.reports.filters.clinics;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(params));
  }

  getGroupsOptionsList(payload: { pageNumber: number, shouldInclude?: any,search?:string, clientId:any }): Observable<DropDownModel['response']> {
    let params = '';
    if (payload.pageNumber) {
      params = `pageNumber=${payload.pageNumber}`
    }

    if (payload?.clientId?.length > 0) {
      params = params + `&clientId=${payload.clientId.join('&clientId=')}`
    }

    if(typeof(payload?.clientId) === 'number' && payload?.clientId){
      params = params + `&clientId=${payload.clientId}`
    }

    if (payload?.shouldInclude?.length > 0) {
      params = params + `&shouldInclude=${payload.shouldInclude.join('&shouldInclude=')}`
    }

    if(typeof(payload?.shouldInclude) === 'number' && payload?.shouldInclude){
      params = params + `&shouldInclude=${payload.shouldInclude}`
    }

    if (payload?.search) {
      params = params + `&search=${payload.search}`
    }

    const urlConfig = v1URL.reports.filters.groups;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(params));
  }

  getBehaviorTypeOptionsList(): Observable<FetchReportsOptions['response']> {
    return of({
      success: true,
      code: 'Dummy Code  ABC1234',
      message: 'Reports Options Fetched SuccessFully',
      data: [
        {
          key: 1,
          value: 'Red Light Food'
        },
        {
          key: 2,
          value: 'Physical Activity'
        },
        {
          key: 3,
          value: 'Screen Time'
        },
      ]
    })
  }

  getParticipantOptionsList(payload:{ pageNumber: number, shouldInclude?: any, username?:string, groupId: any }): Observable<DropDownModel['response']>  {
    const urlConfig = v1URL.reports.filters.participant;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  getQuestionnaireOptionsList(): Observable<DropDownModel['response']>  {
    const urlConfig = v1URL.filters.surveys;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url());
  }

  generateReports(payload:{ reportType:string, reportRequestPayload:any}):Observable<any>{
    const urlConfig = v1URL.reports.generateReports;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.reportType),payload.reportRequestPayload);
  }

  fetchGeneratedReports(payload:{
    pageNumber:number,
    sortColumn?:string,
    sortOrder?:number
  }): Observable<any>{
    const urlConfig = v1URL.reports.fetchReports;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  downloadReports(payload:{
    reportId: number
  }):Observable<any>{
    const urlConfig = v1URL.reports.downloadReports;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.reportId));
  }

  reGenerateReports(payload:{reportId:number}): Observable<any>{
    const urlConfig = v1URL.reports.reGenerateReports;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.reportId));
  }

  checkReportStatus(reportId: number): Observable<any> {
    const urlConfig = v1URL.reports.checkReportStatus;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(reportId));
  }
}
